'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d = require('d3');

var d3 = _interopRequireWildcard(_d);

var _reactSizeme = require('react-sizeme');

var _reactSizeme2 = _interopRequireDefault(_reactSizeme);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // import React, { Component } from 'react';
// import * as d3 from 'd3';
// import { withContentRect } from 'react-measure';

// import theme from './theme';

// const significantFigures = d3.format('.2g');

// const OUTER_HEIGHT = 40;
// const HEIGHT =
//   OUTER_HEIGHT - theme.margin.credibleSetTop - theme.margin.credibleSetBottom;

// class CredibleSet extends Component {
//   state = {};
//   xAxis = d3.axisBottom();
//   xAxisRef = React.createRef();

//   static getDerivedStateFromProps(props) {
//     const { label, data, start, end, contentRect } = props;
//     const { width: outerWidth = 0 } = contentRect.bounds;
//     const width =
//       outerWidth === 0
//         ? 0
//         : outerWidth - theme.margin.left - theme.margin.right;

//     const xScale = d3
//       .scaleLinear()
//       .domain([start, end])
//       .range([0, width]);

//     const posteriorProbabilityScale = d3
//       .scaleLinear()
//       .domain([0, 1])
//       .range(['cyan', 'darkblue']);

//     if (data.length === 0) {
//       console.log(`Empty credible set for ${label}`);
//     }

//     const bars = data.map(d => {
//       return {
//         x: xScale(d.position),
//         color: posteriorProbabilityScale(d.posteriorProbability),
//       };
//     });

//     return { width, bars, xScale };
//   }

//   // componentDidUpdate() {
//   //   const { xScale } = this.state;
//   //   this.xAxis.scale(xScale);
//   //   d3.select(this.xAxisRef.current).call(this.xAxis);
//   // }

//   render() {
//     const { label, measureRef, contentRect, h4, logH4H3 } = this.props;
//     const { width, bars } = this.state;
//     const { width: outerWidth } = contentRect.bounds;

//     return (
//       <div ref={measureRef}>
//         <svg width={outerWidth} height={OUTER_HEIGHT}>
//           <g
//             transform={`translate(${theme.margin.left}, ${
//               theme.margin.credibleSetTop
//             })`}
//           >
//             <text
//               fontSize={14}
//               fontWeight="bold"
//               dy={-5}
//               fill={theme.axis.color}
//             >
//               {label}
//             </text>
//             {logH4H3 && h4 ? (
//               <text
//                 fontSize={14}
//                 fontWeight="bold"
//                 textAnchor="end"
//                 dx={width}
//                 dy={-5}
//                 fill={theme.axis.color}
//               >
//                 log(H4/H3): {significantFigures(logH4H3)}, H4:{' '}
//                 {significantFigures(h4)}
//               </text>
//             ) : null}
//             <rect
//               stroke={theme.track.background}
//               fill={theme.track.backgroundAlternate}
//               x={0}
//               y={0}
//               width={width}
//               height={HEIGHT}
//             />
//           </g>
//           <g
//             transform={`translate(${theme.margin.left}, ${
//               theme.margin.credibleSetTop
//             })`}
//           >
//             {bars.map((bar, i) => {
//               return (
//                 <rect
//                   stroke="none"
//                   fill={bar.color}
//                   key={i}
//                   x={bar.x}
//                   y={0}
//                   width={2}
//                   height={HEIGHT}
//                 />
//               );
//             })}
//           </g>
//           {/* <g
//             ref={this.xAxisRef}
//             transform={`translate(${theme.margin.left}, ${theme.margin
//               .credibleSetTop + HEIGHT})`}
//           /> */}
//         </svg>
//       </div>
//     );
//   }
// }

// export default withContentRect('bounds')(CredibleSet);

var significantFigures = d3.format('.2g');

var OUTER_HEIGHT = 40;
var HEIGHT = OUTER_HEIGHT - _theme2.default.margin.credibleSetTop - _theme2.default.margin.credibleSetBottom;

var CredibleSet = function (_Component) {
  _inherits(CredibleSet, _Component);

  function CredibleSet() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CredibleSet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CredibleSet.__proto__ || Object.getPrototypeOf(CredibleSet)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CredibleSet, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          h4 = _props.h4,
          logH4H3 = _props.logH4H3,
          size = _props.size;
      var _state = this.state,
          width = _state.width,
          bars = _state.bars;
      var outerWidth = size.width;


      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _react2.default.createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            width: outerWidth + 'px',
            height: OUTER_HEIGHT
          },
          _react2.default.createElement(
            'g',
            {
              transform: 'translate(' + _theme2.default.margin.left + ', ' + _theme2.default.margin.credibleSetTop + ')'
            },
            _react2.default.createElement(
              'text',
              {
                fontSize: 14,
                fontWeight: 'bold',
                dy: -5,
                fill: _theme2.default.axis.color
              },
              label
            ),
            logH4H3 && h4 ? _react2.default.createElement(
              'text',
              {
                fontSize: 14,
                fontWeight: 'bold',
                textAnchor: 'end',
                dx: width,
                dy: -5,
                fill: _theme2.default.axis.color
              },
              'log(H4/H3): ',
              significantFigures(logH4H3),
              ', H4:',
              ' ',
              significantFigures(h4)
            ) : null,
            _react2.default.createElement('rect', {
              stroke: _theme2.default.track.background,
              fill: _theme2.default.track.backgroundAlternate,
              x: 0,
              y: 0,
              width: width,
              height: HEIGHT
            })
          ),
          _react2.default.createElement(
            'g',
            {
              transform: 'translate(' + _theme2.default.margin.left + ', ' + _theme2.default.margin.credibleSetTop + ')'
            },
            bars.map(function (bar, i) {
              return _react2.default.createElement('rect', {
                stroke: 'none',
                fill: bar.color,
                key: i,
                x: bar.x,
                y: 0,
                width: 2,
                height: HEIGHT
              });
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props) {
      var label = props.label,
          data = props.data,
          start = props.start,
          end = props.end,
          size = props.size;
      var _size$width = size.width,
          outerWidth = _size$width === undefined ? 0 : _size$width;

      var width = outerWidth === 0 ? 0 : outerWidth - _theme2.default.margin.left - _theme2.default.margin.right;

      var xScale = d3.scaleLinear().domain([start, end]).range([0, width]);

      var posteriorProbabilityScale = d3.scaleLinear().domain([0, 1]).range(['cyan', 'darkblue']);

      if (data.length === 0) {
        console.log('Empty credible set for ' + label);
      }

      var bars = data.map(function (d) {
        return {
          x: xScale(d.position),
          color: posteriorProbabilityScale(d.posteriorProbability)
        };
      });

      return { width: width, bars: bars, xScale: xScale };
    }
  }]);

  return CredibleSet;
}(_react.Component);

exports.default = (0, _reactSizeme2.default)()(CredibleSet);